<template>
  <div class="gmzlrDialog">
    <div class="gmzlrBody">
      <el-form ref="form" :model="form" :rules="rules" :disabled="gmsqtype">
        <div class="imgtitle1" style="position: relative">
          <div
            v-preventReClick
            style="
              position: absolute;
              right: 30px;
              top: 30px;
              font-size: 30px;
              color: #606266;
              cursor: pointer;
            "
            @click="back"
          >
            <i class="el-icon-circle-close" />
          </div>
          <img src="@/assets/img/hxpxx.png" alt="">
        </div>
        <div class="firstbf">
          <el-form-item label="许可证编号:" prop="xkzBh">
            <el-input
              v-model="form.xkzBh"
              placeholder="请输入许可证编号"
            />
          </el-form-item>
          <el-form-item label="化学品:" prop="hxpBm">
            <el-cascader
              ref="hxps"
              v-model="form.hxpBm"
              placeholder="请选择化学品"
              :options="options"
              :props="{ emitPath: false }"
              @change="handleChange"
            />
          </el-form-item>
          <el-form-item>
            <el-col
              :span="16"
            ><el-form-item label="购买数量:" prop="gmsl">
              <el-input
                v-model="form.gmsl"
                placeholder="请输入购买数量"
              /> </el-form-item></el-col>
            <el-col :span="8">
              <el-form-item
                prop="gmslDw"
                :rules="{
                  required: true,
                  message: '请选择',
                  trigger: ['blur', 'change'],
                }"
              >
                <el-select v-model="form.gmslDw" placeholder="请选择单位">
                  <el-option
                    v-for="item in yzd_nsjsl_dw"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select> </el-form-item></el-col>
          </el-form-item>
          <el-form-item label="单价:">
            <el-col :span="16">
              <el-form-item prop="dj">
                <el-input v-model="form.dj" placeholder="请输入单价" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item prop="djDw">
                <el-select v-model="form.djDw" placeholder="请选择单位">
                  <el-option
                    v-for="item in yzd_zjzj"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item label="总价:">
            <el-col :span="16">
              <el-form-item prop="zj">
                <el-input v-model="form.zj" placeholder="请输入总价" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item prop="zjDw">
                <el-select v-model="form.zjDw" placeholder="请选择单位">
                  <el-option
                    v-for="item in yzd_zjzj"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item label="有效期" prop="yxqKs">
            <el-date-picker
              v-model="form.yxqKs"
              type="date"
              value-format="yyyy-MM-dd"
              style="width: 46%"
              placeholder="选择日期"
            />
            至
            <el-date-picker
              v-model="form.yxqJs"
              type="date"
              value-format="yyyy-MM-dd"
              style="width: 48%"
              placeholder="选择日期"
            />
          </el-form-item>
          <el-form-item label="年需求量:">
            <el-col :span="16">
              <el-form-item prop="nxql">
                <el-input
                  v-model="form.nxql"
                  placeholder="请输入年需求量"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item prop="nxqlDw">
                <el-select v-model="form.nxqlDw" placeholder="请选择单位">
                  <el-option
                    v-for="item in yzd_nsjsl_dw"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select> </el-form-item></el-col>
          </el-form-item>
          <el-form-item
            label="用途:"
            prop="yt"
            :rules="{
              required: true,
              validator: (rule, value, callback) => {
                lengthValidate(rule, value, callback, 'bt', 255);
              },
              trigger: ['blur', 'change'],
            }"
          >
            <el-input v-model="form.yt" placeholder="请输入用途" />
          </el-form-item>
          <el-form-item
            label="有效次数:"
            prop="yxcs"
            :rules="{
              required: true,
              message: '请选择',
              trigger: ['blur', 'change'],
            }"
          >
            <el-select v-model="form.yxcs" placeholder="请选择有效次数">
              <el-option label="一次有效" value="1" />
              <el-option label="多次有效" value="2" />
            </el-select>
          </el-form-item>
          <el-form-item label="核发日期:" prop="hfrq">
            <el-date-picker
              v-model="form.hfrq"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
            />
          </el-form-item>
          <el-form-item label="经办人姓名:" prop="jbrXm">
            <el-input v-model="form.jbrXm" placeholder="请输入经办人姓名" />
          </el-form-item>
          <el-form-item label="经办人身份证:" prop="jbrSfzh">
            <el-input
              v-model="form.jbrSfzh"
              placeholder="请输入经办人身份证"
            />
          </el-form-item>
          <el-form-item label="经办人手机号:" prop="jbrSjh">
            <el-input
              v-model="form.jbrSjh"
              placeholder="请输入经办人手机号"
            />
          </el-form-item>
          <!-- <el-form-item label="核发日期">
            <el-date-picker
              type="date"
              v-model="form.hfrq"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
            >
            </el-date-picker>
          </el-form-item> -->
          <!-- <el-form-item label="行政区划:">
            <el-input
              v-model="form.jbrSfzh"
              placeholder="请输入行政区划"
            ></el-input>
          </el-form-item> -->
          <!-- <el-form-item label="备注:">
            <el-input
              disabled
              v-model="form.jbrSfzh"
              placeholder="请填写备注"
            ></el-input>
          </el-form-item> -->
        </div>
        <!-- 购买单位 -->
        <div class="imgtitle2">
          <img src="@/assets/img/gmdwxx.png" alt="">
        </div>
        <div class="secondbf">
          <el-form-item label="单位名称:" prop="gmdwMc">
            <el-input
              v-model="form.gmdwMc"
              placeholder="请输入单位名称"
            />
          </el-form-item>
          <el-form-item
            label="统一社会信用代码:"
            prop="gmdwShtyxydm"
            label-width="140px"
          >
            <el-input
              v-model="form.gmdwShtyxydm"
              placeholder="请输入统一社会信用代码"
            />
          </el-form-item>
          <el-form-item
            label="单位法人/经营者:"
            prop="gmdwFr"
            label-width="140px"
          >
            <el-input v-model="form.gmdwFr" placeholder="请输入单位法人/经营者" />
          </el-form-item>
          <el-form-item label="单位座机:" prop="gmdwDh">
            <el-input
              v-model="form.gmdwDh"
              placeholder="请输入单位座机"
            />
          </el-form-item>
          <el-form-item label="单位地址:" prop="gmdwZsdz">
            <el-input v-model="form.gmdwZsdz" placeholder="请输入单位地址" />
          </el-form-item>
        </div>
        <div class="imgtitle2">
          <img src="@/assets/img/xsdwxx.png" alt="">
        </div>
        <div class="secondbf">
          <el-form-item
            label="单位名称:"
            prop="xsdwMc"
            :rules="{
              required: true,
              validator: (rule, value, callback) => {
                lengthValidate(rule, value, callback, 'bt', 200);
              },
              trigger: ['blur', 'change'],
            }"
          >
            <el-input
              v-model="form.xsdwMc"
              placeholder="请输入单位名称"
            />
          </el-form-item>
          <el-form-item
            label="统一社会信用代码:"
            prop="xsdwTyshxydm"
            label-width="140px"
          >
            <el-input
              v-model="form.xsdwTyshxydm"
              placeholder="请输入统一社会信用代码"
            />
          </el-form-item>
          <el-form-item
            label="单位法人/经营者:"
            prop="xsdwDwfr"
            label-width="140px"
          >
            <el-input
              v-model="form.xsdwDwfr"
              placeholder="请输入单位法人/经营者"
            />
          </el-form-item>
          <el-form-item label="单位座机:" prop="xsdwDwzj">
            <el-input v-model="form.xsdwDwzj" placeholder="请输入单位座机" />
          </el-form-item>
          <el-form-item label="单位地址:" prop="xsdwDwdz">
            <el-input v-model="form.xsdwDwdz" placeholder="请输入单位地址" />
          </el-form-item>
          <el-form-item
            label="联系人姓名:"
            prop="xsdwLxrxm"
            :rules="{
              required: true,
              validator: (rule, value, callback) => {
                lengthValidate(rule, value, callback, 'bt', 200);
              },
              trigger: ['blur', 'change'],
            }"
          >
            <el-input v-model="form.xsdwLxrxm" placeholder="请输入联系人姓名" />
          </el-form-item>
          <el-form-item
            label="联系人身份证:"
            prop="xsdwLxrsfzh"
            :rules="{
              required: true,
              validator: (rule, value, callback) => {
                lengthValidate(rule, value, callback, 'bt', 100);
              },
              trigger: ['blur', 'change'],
            }"
          >
            <el-input
              v-model="form.xsdwLxrsfzh"
              placeholder="请输入联系人身份证"
            />
          </el-form-item>
          <el-form-item label="联系人手机号:" prop="xsdwLxrsjhm">
            <el-input
              v-model="form.xsdwLxrsjhm"
              placeholder="请输入联系人手机号"
            />
          </el-form-item>
          <el-form-item
            label="企业来源:"
            prop="xsdwLy"
            class="is-required"
            style="width: 100% !important;"
          >
            <el-checkbox-group
              v-model="xsdwLyList"
              :disabled="gmsqtype"
              @change="xsdwLyChange"
            >
              <el-checkbox label="0">国内(非港澳台)</el-checkbox>
              <el-checkbox label="2">国内(港澳台)</el-checkbox>
              <el-checkbox label="1">国外</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </div>
        <div class="imgtitle3">
          <img src="@/assets/img/xgcl.png" alt="">
        </div>
        <div class="tishi">
          <p>
            <img src="@/assets/img/tishi.png" alt="">
            提示：提交“中华人民共和国两用物项和技术出口许可证”、“中华人民共和国两用物项和技术进口许可证”或“药品类易制毒化学品购用证明”；支持上传png、jpg、bmp、jpeg格式，500KB以内证件照片。
          </p>
          <el-upload
            class="avatar-uploader"
            :show-file-list="false"
            :action="returnSaveFile"
            :before-upload="beforeUpload"
            :on-success="onSuccess"
            :on-error="onError"
            :headers="token"
          >
            <img
              v-if="imageUrlFlag"
              style="width: 180px; height: 180px; margin-right: 0px"
              :src="imageUrl"
              class="avatar"
            >
            <i v-else class="el-icon-plus avatar-uploader-icon" />
          </el-upload>
        </div>
      </el-form>
    </div>

    <div v-if="gmsqtype" class="buttonList">
      <el-button class="tjsq" @click="back">关闭</el-button>
    </div>
    <div v-else class="buttonList">
      <el-button class="tjsq" @click="record">录入</el-button>
    </div>
  </div>
</template>
<script>
// 获取接口地址
import {
  getkv,
  gethxpJlgmzLR,
  getToken,
  getGmzLrSldw,
  returnShowPic, returnSaveFile
} from '@/assets/js/common.js'
import { lengthValidate } from '@/assets/js/validate.js'
import { gmzRecord } from '@/assets/js/gmzlr.js'
export default {
  name: 'Gmzlr',
  components: {},
  props: {
    gmsqtype: {
      type: Boolean
    }
  },
  data() {
    const xsdwDwzjValidator = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入电话或手机号'))
      } else {
        const reg1 = /^(0\d{2,3}-\d{7,8})$/ // 座机
        const reg2 = /^1[3456789]\d{9}$/
        if (!reg1.test(value) && !reg2.test(value)) {
          callback(new Error('请输入正确的电话或手机号格式'))
        }
      }
      callback()
    }
    const xsdwLxrsjhmValidator = (rule, value, callback) => {
      if (value) {
        const reg = /^1[3456789]\d{9}$/
        if (!reg.test(value)) {
          callback(new Error('请输入正确的手机号'))
        } else {
          callback()
        }
      } else {
        callback()
      }
    }
    const jbrSjhValidator = (rule, value, callback) => {
      if (value) {
        const reg = /^1[3456789]\d{9}$/
        if (!reg.test(value)) {
          callback(new Error('请输入正确的手机号'))
        } else {
          callback()
        }
      } else {
        callback()
      }
    }
    const nxqlDwValidator = (rule, value, callback) => {
      if (!this.form.nxql) {
        callback()
      } else if (!value) {
        callback(new Error('请选择货币'))
      }
      callback()
    }
    const nxqlValidator = (rule, value, callback) => {
      if (!value) {
        callback()
      } else {
        if (/^[1-9]\d{0,8}(\.\d{1,3})?$|^0(\.\d{1,3})?$/.test(value) == false) {
          callback(new Error('整数位最大长度9位,保留3位小数'))
        }
      }
      callback()
    }
    const zjDwValidator = (rule, value, callback) => {
      if (!this.form.zj) {
        callback()
      } else if (!value) {
        callback(new Error('请选择货币'))
      }
      callback()
    }
    const zjValidator = (rule, value, callback) => {
      if (!value) {
        callback()
      } else {
        if (/^[1-9]\d{0,8}(\.\d{1,3})?$|^0(\.\d{1,3})?$/.test(value) == false) {
          callback(new Error('整数位最大长度9位,保留3位小数'))
        }
      }
      callback()
    }
    const djdwValidator = (rule, value, callback) => {
      if (!this.form.dj) {
        callback()
      } else if (!value) {
        callback(new Error('请选择货币'))
      }
      callback()
    }
    const djValidator = (rule, value, callback) => {
      if (!value) {
        callback()
      } else {
        if (/^[1-9]\d{0,6}(\.\d{1,2})?$|^0(\.\d{1,2})?$/.test(value) == false) {
          callback(new Error('整数位最大长度7位,保留2位小数'))
        }
      }
      callback()
    }
    const numberValidator = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入'))
      } else if (
        /^[1-9]\d{0,8}(\.\d{1,3})?$|^0(\.\d{1,3})?$/.test(value) == false
      ) {
        callback(new Error('整数位最大长度9位,保留3位小数'))
      }
      callback()
    }
    const yxqValidator = (rule, value, callback) => {
      if (!this.form.yxqKs) {
        callback(new Error('请选择有效期开始时间'))
      } else if (!this.form.yxqJs) {
        callback(new Error('请选择有效期结束时间'))
      }
      callback()
    }
    const xsdwLyValidator = (rule, value, callback) => {
      if (!this.form.xsdwLy) {
        callback(new Error('请选择企业来源'))
      }
      callback()
    }
    return {
      form: {
        yxcs: '1',
        xkzGmFjxxList: [
          {
            zjlx: '22',
            xsdwLy:'',
            fjList: [
              {
                zjlx: '22',
                wjdz: ''
              }
            ]
          }
        ]
      },
      returnSaveFile: '', // 保存图片
      returnShowPic: '', // 回显图片
      yxcslist: [],
      xsdwLyList: [],
      yzd_zjzj: [], // 总价单价单位信息
      yzd_nsjsl_dw: [], // 单位信息
      imageUrl: '',
      imageUrlFlag: false,
      options: [], // 化学品级联数据
      hxpsdata: {},
      token: {
        Authorization: getToken()
      },
      rules: {
        xsdwLxrsjhm: [
          {
            required: true,
            // validator: xsdwLxrsjhmValidator,
            message: '请输入联系人手机号',
            trigger: ['blur', 'change']
          }
        ],
        jbrSjh: [{ validator: jbrSjhValidator, trigger: ['blur', 'change'] }],
        xsdwLy: [{ validator: xsdwLyValidator, trigger: ['blur', 'change'] }],
        nxqlDw: [{ validator: nxqlDwValidator, trigger: ['blur', 'change'] }],
        nxql: [{ validator: nxqlValidator, trigger: ['blur', 'change'] }],
        zjDw: [{ validator: zjDwValidator, trigger: ['blur', 'change'] }],
        zj: [{ validator: zjValidator, trigger: ['blur', 'change'] }],
        djDw: [{ validator: djdwValidator, trigger: ['blur', 'change'] }],
        dj: [{ validator: djValidator, trigger: ['blur', 'change'] }],
        jbrXm: [
          {
            validator: (rule, value, callback) => {
              lengthValidate(rule, value, callback, 'xt', 200)
            },
            trigger: ['blur', 'change']
          }
        ],
        jbrSfzh: [
          {
            validator: (rule, value, callback) => {
              lengthValidate(rule, value, callback, 'xt', 100)
            },
            trigger: ['blur', 'change']
          }
        ],
        gmsl: [
          {
            required: true,
            validator: numberValidator,
            trigger: ['blur', 'change']
          }
        ],
        xkzBh: [
          {
            required: true,
            validator: (rule, value, callback) => {
              lengthValidate(rule, value, callback, 'bt', 30)
            },
            trigger: 'change'
          }
        ],
        hxpBm: [{ required: true, message: '请选择化学品', trigger: 'change' }],
        yxqKs: [{ required: true, validator: yxqValidator, trigger: 'change' }],
        hfrq: [
          { required: true, message: '请选择核发日期', trigger: 'change' }
        ],
        xsdwDwzj: [
          {
            required: true,
            validator: xsdwDwzjValidator,
            trigger: 'change'
          }
        ],
        xsdwDwdz: [
          {
            required: true,
            validator: (rule, value, callback) => {
              lengthValidate(rule, value, callback, 'bt', 600)
            },
            trigger: 'change'
          }
        ],
        xsdwDwfr: [
          {
            required: true,
            validator: (rule, value, callback) => {
              lengthValidate(rule, value, callback, 'bt', 200)
            },
            trigger: 'change'
          }
        ],
        xsdwTyshxydm: [
          {
            required: true,
            validator: (rule, value, callback) => {
              lengthValidate(rule, value, callback, 'bt', 100)
            },
            trigger: 'change'
          }
        ],
        /* 购买单位 */
        gmdwMc: [
          {
            required: true,
            validator: (rule, value, callback) => {
              lengthValidate(rule, value, callback, 'bt', 200)
            },
            trigger: 'change'
          }
        ],
        gmdwZsdz: [
          {
            required: true,
            validator: (rule, value, callback) => {
              lengthValidate(rule, value, callback, 'bt', 600)
            },
            trigger: 'change'
          }
        ],
        gmdwFr: [
          {
            required: true,
            validator: (rule, value, callback) => {
              lengthValidate(rule, value, callback, 'bt', 200)
            },
            trigger: 'change'
          }
        ],
        gmdwDh: [
          {
            required: true,
            validator: xsdwDwzjValidator,
            trigger: 'change'
          }
        ],
        gmdwShtyxydm: [
          {
            required: true,
            validator: (rule, value, callback) => {
              lengthValidate(rule, value, callback, 'bt', 100)
            },
            trigger: 'change'
          }
        ]
      }
    }
  },
  computed: {},
  watch: {
    'form.xkzGmFjxxList'(newValue, oldValeu) {
      if (newValue.length > 0 && newValue[0].fjList[0].wjdz !== '') {
        this.imageUrl = this.returnShowPic + newValue[0].fjList[0].wjdz
        this.imageUrlFlag = true
      }
    },
    'form.hxpBm'() {
      if (this.form.hxpBm) {
        getGmzLrSldw(this.form.hxpBm).then((e) => {
          this.yzd_nsjsl_dw = e.data.data
        })
      }
    }
  },
  mounted() { },
  created() {
    this.returnShowPic = returnShowPic()
    this.returnSaveFile = returnSaveFile()
    // 获取化学品级联数据
    gethxpJlgmzLR().then((e) => {
      this.options = e.data.data
    })
    // 单价总价单位
    getkv('yzd_xkzdjdw').then((e) => {
      this.yzd_zjzj = e.data.data
    })
  },
  methods: {
    lengthValidate,
    xsdwLyChange(value) {
      if (value.slice(-1) != '') {
        this.xsdwLyList = []
        this.form.xsdwLy = value.slice(-1).toString()
        this.xsdwLyList.push(value.slice(-1).toString())
      } else this.xsdwLyList.push(this.form.xsdwLy)
    },
    record() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          gmzRecord(this.form).then((e) => {
            if (e.data.code == '000000') {
              this.$message.success('提交成功!')
              this.$parent.closeDialog()
            }
          })
        }
      })
    },
    handleChange(value) {
      this.hxpsdata = this.$refs.hxps.getCheckedNodes()[0].data
      this.form.hxpMc = this.hxpsdata.label
      // //化学品数量单位
      // getGmzLrSldw(this.hxpsdata.value).then((e) => {
      //   this.yzd_nsjsl_dw = e.data.data;
      // });
    },
    back() {
      this.reset()
    },
    reset() {
      this.form = {}
      this.$refs['form'].resetFields()
      this.$parent.closeDialog()
      this.imageUrl = ''
      this.imageUrlFlag = false
    },
    beforeUpload(file) {
      const fileType = ['image/jpeg', 'image/png', 'image/bmp', 'image/jpg']
      const isJPG = fileType.includes(file.type)

      const isLt = file.size / 1024 < 500
      if (!isJPG) {
        this.$message.error('上传图片只能是 JPG/BMP/JPEG/PNG格式!')
      }
      if (!isLt) {
        this.$message.error('上传图片大小不能超过 500kb!')
      }
      return isJPG && isLt
    },
    onSuccess(response, file, fileList) {
      // todo
      this.imageUrl = this.returnShowPic + response.data.url
      this.imageUrlFlag = true
      this.form.xkzGmFjxxList[0].fjList[0].wjdz = response.data.url
    },
    onError() {
      this.$message.error('证件上传失败!')
    }
  }
}
</script>

<style lang="less" scoped>
.gmzlrDialog {
  width: 95%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0;
  background-color: #fff;
  .gmzlrBody {
    .tishi {
      padding: 0 117px 31px;

      img {
        width: 15px;
        height: 15px;
        margin-right: 5px;
        vertical-align: middle;
      }
      p {
        display: inline-block;
        height: 18px;
        font-size: 13px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #636363;
        line-height: 18px;
        margin-bottom: 40px;
      }
    }
    .imgtitle3 {
      padding: 40px 117px 28px 117px;
      img {
        width: 91px;
      }
    }
    .imgtitle2,
    .imgtitle1 {
      padding: 40px 117px;
      img {
        height: 22px;
        width: 145px;
      }
    }
    /deep/ .el-form {
      .firstbf,
      .secondbf {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        padding: 0 117px 40px;
        border-bottom: 10px solid #eef1f9;
        .el-form-item {
          margin-right: 0px;
          margin-bottom: 20px;
          height: 39px;
          width: 47% !important;
          .el-switch {
            height: 39px;
          }
          .el-form-item__content {
            display: flex;
          }
        }
        .el-col-16,
        .el-col-8 {
          .el-form-item {
            width: 100% !important;
          }
        }
      }
      .firstbf {
        .el-form-item {
          &:nth-child(1),
          &:nth-child(3),
          &:nth-child(5),
          &:nth-child(7),
          &:nth-child(9),
          &:nth-child(11),
          &:nth-child(12) {
            .el-form-item__label {
              width: 103px;
            }
          }
          &:nth-child(2),
          &:nth-child(4),
          &:nth-child(6),
          &:nth-child(8) {
            .el-form-item__label {
              width: 88px;
            }
          }
          &:nth-child(2) {
            .el-cascader {
              width: 100% !important;
            }
          }
          &:nth-child(1),
          &:nth-child(6),
          &:nth-child(7),
          &:nth-child(8),
          &:nth-child(10) {
            .el-form-item__content {
              .el-select {
                width: 100% !important;
              }
              .el-cascader {
                width: 100% !important;
              }
              .el-date-editor {
                width: 100% !important;
              }
            }
          }
          &:nth-child(3),
          &:nth-child(4),
          &:nth-child(5),
          &:nth-child(7) {
            .el-form-item__content {
              & > .el-input {
                margin-right: 10px;
              }
            }
          }
          &:nth-child(9) {
            .el-select {
              width: 100% !important;
            }
          }

          &:nth-child(10),
          &:nth-child(11),
          &:nth-child(12) {
            .el-form-item__label {
              width: 110px;
            }
          }
        }
      }
      .secondbf {
        .el-form-item {
          &:nth-child(1),
          &:nth-child(3),
          &:nth-child(5),
          &:nth-child(7),
          &:nth-child(9) {
            .el-form-item__label {
              width: 120px;
            }
          }
          &:nth-child(2),
          &:nth-child(4),
          &:nth-child(6),
          &:nth-child(8) {
            .el-form-item__label {
              width: 135px;
            }
          }
          &:nth-child(2) {
            .el-form-item__label {
              width: 138px;
            }
          }
          &:nth-child(1) {
            .el-form-item__content {
              .el-button--primary {
                margin-left: 7px;
              }
            }
          }

          &:nth-child(2),
          &:nth-child(3),
          &:nth-child(4),
          &:nth-child(5),
          &:nth-child(6),
          &:nth-child(7),
          &:nth-child(8) {
            .el-select {
              width: 100% !important;
            }
          }

          &:nth-child(9) {
            width: 100% !important;
          }
        }
      }
    }
  }
}
.buttonList {
  padding-top: 50px;
  padding-bottom: 50px;
  display: flex;
  justify-content: space-evenly;
  .tjsq {
    color: #ffffff;
    width: 148px;
    height: 60px;
    background: #4170ff;
    border-radius: 5px;
    border: none;
  }
}
/deep/.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
/deep/.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
/deep/.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
</style>
